module.exports = __webpack_public_path__ + "static/media/ruspolymet.693890f6.png";